import ProofImagesContextProvider from './ProofImagesContextProvider';
import ProofExternalFilesContextProvider from './ProofExternalFilesContextProvider';
import ProofFilesAndLinks from './ProofFilesAndLinks';
import AttachmentSectionTitle from '../AttachmentSectionTitle';
import { FormattedMessage } from 'react-intl';
import AttachmentSection from '../AttachmentSection';

type LevelProofProps = {
  levelId: number;
};

const LevelProof = ({ levelId }: LevelProofProps) => (
  <AttachmentSection>
    <AttachmentSectionTitle>
      <FormattedMessage id="portfolio.level.attachments.proof.section_title" />
    </AttachmentSectionTitle>
    <ProofImagesContextProvider levelId={levelId}>
      <ProofExternalFilesContextProvider levelId={levelId}>
        <ProofFilesAndLinks levelId={levelId} />
      </ProofExternalFilesContextProvider>
    </ProofImagesContextProvider>
  </AttachmentSection>
);

export default LevelProof;
